module.exports = __webpack_public_path__ + "img/PMS_HBP.e6807e74.gif";